import LazyLoading from './common/lazyLoading';
import LoadPurchase from './common/loadPurchase.js';
import LoadSpeechSearch from './components/loadSpeechSearch.js';
import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
import Header from './common/header';
import Webforms from './common/webforms';
import Price from './components/price/price.js';
import CountdownBanner from './components/countdownBanner.js';
import { NewsletterComponent } from './components/vndaComponents.js';
import { setSearch } from './components/utilities';
import TextType from './components/textType';
import Silk from './components/silk';  
 
// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Header.init();
  Price.init();
  LazyLoading.init();
  LoadPurchase.init();
  LoadSpeechSearch.init()
  CartDrawer.init();
  Footer.init();
  Webforms.init();
  NewsletterComponent.init();
  new CountdownBanner().init();
  setSearch();
  Silk.init();
  TextType.init();
  // Animação de troca de palavras no hero animado (fade/slide)
  const heroSection = document.querySelector('.section-hero-animado');
  if (heroSection) {
    const words = ["incrível", "novo", "maravilhoso", "bonito", "inteligente"]; 
    let idx = 0;
    const animado = heroSection.querySelector('.hero-titulo-animado');
    if (animado) {
      animado.textContent = words[0];
      animado.style.opacity = 1;
      animado.style.transform = 'translateY(0)';
      setInterval(() => {
        animado.style.opacity = 0;
        animado.style.transform = 'translateY(40px)';
        setTimeout(() => {
          idx = (idx + 1) % words.length;
          animado.textContent = words[idx];
          animado.style.transform = 'translateY(-40px)';
          setTimeout(() => {
            animado.style.opacity = 1;
            animado.style.transform = 'translateY(0)';
          }, 50);
        }, 400);
      }, 2000);
    }
  }
    // Efeito spotlight e loader fake para a seção 3D
    const splineSection = document.querySelector('.section-3d-spline-demo');
    if (splineSection) {
      // Spotlight animado
      const spotlight = splineSection.querySelector('.spline-spotlight');
      if (spotlight) {
        let angle = 0;
        setInterval(() => {
          angle += 0.5;
          spotlight.style.background = `radial-gradient(ellipse at ${60 + 20*Math.sin(angle/20)}% 0%, rgba(255,255,255,0.13) 0%, transparent 80%)`;
        }, 60);
      }
      // Loader fake
      const img = splineSection.querySelector('.spline-3d-img');
      const loader = splineSection.querySelector('.spline-loader');
      if (img && loader) {
        loader.style.opacity = '1';
        img.onload = () => { loader.style.opacity = '0'; };
        if (img.complete) loader.style.opacity = '0';
      }
    }
  // Animação de entrada para o bloco inovacao ilimitada
  const inovacaoCard = document.querySelector('.section-inovacao-ilimitada [data-animation-on-scroll]');
  if (inovacaoCard) {
    inovacaoCard.classList.add('animate-on-scroll-hidden');
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-on-scroll-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    observer.observe(inovacaoCard);
  }
  // Inicializa a seção Features se existir o container
  if (window.FeaturesSection && document.getElementById('features-section')) {
    window.FeaturesSection.init();
  }
});
